export const localiseUrl = (
  url: string,
  options: Options = {
    locale: 'en',
    localeAsParam: false,
    availableLocales: []
  }
): string => {
  if (!url) return '/'

  const { locale, localeAsParam, availableLocales } = options

  // if URL is absolute split the origin and pathname and recurse the function with pathname
  if (url.startsWith('http') || url.startsWith('//')) {
    const { origin, pathname, search } = new URL(url)
    const relativeUrl = localiseUrl(pathname + search, options)

    return origin + relativeUrl
  }

  // Removes lingering '/' if present
  let path = url.endsWith('/') ? url.slice(0, -1) : url
  const parts = path.split('/')

  // Check if the first part of the path is a language code
  if (parts.length > 1 && availableLocales.includes(parts[1])) {
    // Remove the language code from the path
    parts.splice(1, 1)
    path = parts.join('/')
  }

  // If we want params only we dont need to adjust the url
  if (localeAsParam) {
    if (locale === 'en') return path

    const operator = url.split('?').length > 1 ? '&' : '?'

    return `${path}${operator}locale=${locale}`
  }

  // Prepend the locale subdirectory to the path if specified and valid
  if (availableLocales.filter((loc) => loc !== 'en').includes(locale)) {
    path = `/${locale}${path}`
  }

  // Reconstruct the URL
  return path || '/'
}

interface Options {
  locale: string
  localeAsParam: boolean
  availableLocales: string[]
}
